import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { GoogleLogo, ArrowRight } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

const Login = () => {
  const { loginEmail, loginGoogle } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await loginEmail(email, password);
      toast.success("Bienvenido");
      const dest = location.state?.from?.pathname || "/dashboard";
      navigate(dest);
    } catch (err) {
      toast.error(err?.message || "No se pudo iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  const handleGoogle = async () => {
    try { await loginGoogle(); }
    catch (err) { toast.error(err?.message || "Error con Google"); }
  };

  return (
    <div className="min-h-[80vh] grid lg:grid-cols-2" data-testid="login-page">
      <div className="hidden lg:block relative overflow-hidden bg-mist">
        <img src="https://images.pexels.com/photos/8436686/pexels-photo-8436686.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940" alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-paper via-paper/30 to-transparent" />
        <div className="absolute bottom-12 left-12 max-w-md">
          <h2 className="font-heading text-5xl font-light leading-tight text-forest">Bienvenido de vuelta, <span className="serif-italic font-medium text-sage-deep">respira</span>.</h2>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 md:p-16 bg-paper">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
          <span className="text-[11px] uppercase tracking-[0.3em] text-sage-deep block mb-3">/ acceso</span>
          <h1 className="font-heading text-4xl font-light text-forest mb-2">Inicia sesión</h1>
          <p className="text-stone text-sm mb-8">¿Aún no tienes cuenta? <Link to="/registro" className="text-sage-deep hover:underline">Crear cuenta</Link></p>

          <button onClick={handleGoogle} data-testid="google-login-btn" className="w-full flex items-center justify-center gap-3 border border-forest/15 bg-white py-3.5 hover:bg-mist transition mb-4 rounded-full">
            <GoogleLogo size={20} weight="bold" /> <span className="text-sm">Continuar con Google</span>
          </button>

          <div className="flex items-center gap-3 my-6 text-[10px] uppercase tracking-[0.3em] text-ash">
            <div className="flex-1 h-px bg-forest/10" /> o con email <div className="flex-1 h-px bg-forest/10" />
          </div>

          <form onSubmit={submit} className="space-y-4">
            <label className="block">
              <span className="text-[10px] uppercase tracking-[0.2em] text-stone">Email</span>
              <input data-testid="login-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 w-full bg-white border border-forest/15 px-4 py-3 text-sm focus:border-sage-deep focus:outline-none rounded-md" />
            </label>
            <label className="block">
              <span className="text-[10px] uppercase tracking-[0.2em] text-stone">Contraseña</span>
              <input data-testid="login-password" required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 w-full bg-white border border-forest/15 px-4 py-3 text-sm focus:border-sage-deep focus:outline-none rounded-md" />
            </label>
            <button type="submit" disabled={loading} data-testid="login-submit-btn" className="w-full bg-sage-deep text-paper py-3.5 font-medium tracking-wide text-sm hover:bg-forest transition flex items-center justify-center gap-2 disabled:opacity-50 rounded-full">
              {loading ? "Entrando…" : <>Entrar <ArrowRight size={16} /></>}
            </button>
          </form>
        </motion.div>
      </div>
    </div>
  );
};

export default Login;
